var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInputYellow16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C1093EC9-D915-4E11-A0CA-51DB82C93718_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaardid---Expanded",
    transform: "translate(-290.000000, -1355.000000)",
    stroke: "#F0B423",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(208.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(0.000000, 816.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaart-/-Master-Copy-4",
    transform: "translate(0.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(24.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(59.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Input_Yellow-16px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.05263158,11.8857143 L1.68421053,11.8857143 C0.757894737,11.8857143 0,11.0628571 0,10.0571429 L0,5.48571429 C0,4.48 0.757894737,3.65714286 1.68421053,3.65714286 L5.05263158,3.65714286",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9473684,3.65714286 L14.3157895,3.65714286 C15.2421053,3.65714286 16,4.48 16,5.48571429 L16,10.0571429 C16,11.0628571 15.2421053,11.8857143 14.3157895,11.8857143 L10.9473684,11.8857143",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05263158,0 L10.9473684,0",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05263158,15.5428571 L10.9473684,15.5428571",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L8,15.5428571",
    id: "Stroke-9"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInputYellow16Px);
export default __webpack_public_path__ + "static/media/Icon_Input_Yellow-16px.dba7a087163a6838fa81888b28ee3111.svg";
export { ForwardRef as ReactComponent };